const SobreEvento = () => {
  return (
    <section id="sobre-evento">
      <div className="titulo">
        <div className="container">
          <h1>Sobre o evento</h1>
        </div>
      </div>

      <div className="conteudo">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-6">
              <p>
                O Líderes do Sucesso é um encontro anual que busca impulsionar,
                estabelecer conexões e desenvolver o nosso time comercial.
              </p>

              <p>
                A cada edição, especialistas de alto nível apresentam técnicas
                avançadas e boas práticas que vão aprimorar e impulsionar o
                desempenho das equipes.
              </p>
            </div>
            <div className="col-12 col-md-6">
              <p>
                Uma experiência transformadora: Junte-se a nós e embarque em uma
                jornada rumo ao sucesso e à superação de limites.
              </p>
              <p>
                Vamos com tudo! 🚀
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SobreEvento;
